/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ValidateInvitationQueryResponse, ValidateInvitationPathParams, ValidateInvitation400, ValidateInvitation401, ValidateInvitation403, ValidateInvitation404, ValidateInvitation409, ValidateInvitation500 } from "../../types/staffController/ValidateInvitation.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getValidateInvitationUrl(token: ValidateInvitationPathParams["token"]) {
  const res = { method: 'GET', url: `/api/invitations/validate/${token}` as const }
  return res
}

/**
 * @summary Validate invitation token
 * {@link /api/invitations/validate/:token}
 */
export async function validateInvitation(token: ValidateInvitationPathParams["token"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ValidateInvitationQueryResponse, ResponseErrorConfig<ValidateInvitation400 | ValidateInvitation401 | ValidateInvitation403 | ValidateInvitation404 | ValidateInvitation409 | ValidateInvitation500>, unknown>({ method : "GET", url : getValidateInvitationUrl(token).url.toString(), ... requestConfig })
  return res.data
}